export default __webpack_public_path__ + "static/media/regulatory--text--g1.14bfe577.png";